"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LiveRegionMessage = exports.MessageBlock = exports.LiveRegion = exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf4 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _convertUnsafeMethod = _interopRequireDefault(require("./convertUnsafeMethod"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

require("./style/index.css");

var _VisuallyHidden = _interopRequireDefault(require("../VisuallyHidden"));

var _class, _class2, _temp;

/* Inspired by https://github.com/AlmeroSteyn/react-aria-live */
var liveRegionAnnouncer = null;
var node = null;
var clearAssertiveTimeoutId = null;
var clearPoliteTimeoutId = null;
var LIVEREGION_TIMEOUT_DELAY = 1000;

var LiveRegionAnnouncer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(LiveRegionAnnouncer, _Component);

  function LiveRegionAnnouncer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, LiveRegionAnnouncer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf4["default"])(LiveRegionAnnouncer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      assertiveMessage: '',
      politeMessage: ''
    });
    return _this;
  }

  (0, _createClass2["default"])(LiveRegionAnnouncer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (node) {
        document.body.removeChild(node);
      }

      liveRegionAnnouncer = null;
      node = null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          assertiveMessage = _this$state.assertiveMessage,
          politeMessage = _this$state.politeMessage;
      return _react["default"].createElement(LiveRegion, {
        assertiveMessage: assertiveMessage,
        politeMessage: politeMessage
      });
    }
  }], [{
    key: "getInstance",
    value: function getInstance(callback, context) {
      if (!liveRegionAnnouncer) {
        node = document.createElement('div');
        document.body.appendChild(node);

        _reactDom["default"].render(_react["default"].createElement(LiveRegionAnnouncer, {
          ref: function ref(l) {
            return liveRegionAnnouncer = l;
          }
        }), node, callback);
      } else if (callback) {
        callback();
      }

      return liveRegionAnnouncer;
    }
  }, {
    key: "destroyInstance",
    value: function destroyInstance(callback) {
      if (liveRegionAnnouncer) {
        liveRegionAnnouncer.setState({
          assertiveMessage: '',
          politeMessage: ''
        }, function () {
          var instanceNode = _reactDom["default"].findDOMNode(liveRegionAnnouncer);

          instanceNode && _reactDom["default"].unmountComponentAtNode(instanceNode.parentNode);

          if (callback) {
            // wait a frame for component to unmount
            setTimeout(callback, 50);
          }
        });
      }
    }
  }, {
    key: "announceAssertive",
    value: function announceAssertive(message) {
      var timeoutDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LIVEREGION_TIMEOUT_DELAY;

      if (clearAssertiveTimeoutId) {
        clearTimeout(clearAssertiveTimeoutId);
        clearAssertiveTimeoutId = null;
      }

      LiveRegionAnnouncer.getInstance(function () {
        return liveRegionAnnouncer.setState({
          assertiveMessage: message
        }, function () {
          if (message !== '') {
            clearAssertiveTimeoutId = setTimeout(function () {
              return LiveRegionAnnouncer.clearMessage('assertive');
            }, timeoutDuration);
          }
        });
      });
    }
  }, {
    key: "announcePolite",
    value: function announcePolite(message) {
      var timeoutDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LIVEREGION_TIMEOUT_DELAY;

      if (clearPoliteTimeoutId) {
        clearTimeout(clearPoliteTimeoutId);
        clearPoliteTimeoutId = null;
      }

      LiveRegionAnnouncer.getInstance(function () {
        return liveRegionAnnouncer.setState({
          politeMessage: message
        }, function () {
          if (message !== '') {
            clearPoliteTimeoutId = setTimeout(function () {
              return LiveRegionAnnouncer.clearMessage('polite');
            }, timeoutDuration);
          }
        });
      });
    }
  }, {
    key: "clearMessage",
    value: function clearMessage(politeness) {
      LiveRegionAnnouncer.getInstance(function () {
        if (!politeness) {
          LiveRegionAnnouncer.announceAssertive('');
          LiveRegionAnnouncer.announcePolite('');
        } else {
          liveRegionAnnouncer.setState((0, _defineProperty2["default"])({}, politeness + 'Message', ''));
        }
      });
    }
  }]);
  return LiveRegionAnnouncer;
}(_react.Component);

exports["default"] = LiveRegionAnnouncer;

var LiveRegion = (0, _convertUnsafeMethod["default"])(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component2) {
  (0, _inherits2["default"])(LiveRegion, _Component2);

  function LiveRegion() {
    var _getPrototypeOf3;

    var _this2;

    (0, _classCallCheck2["default"])(this, LiveRegion);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf3 = (0, _getPrototypeOf4["default"])(LiveRegion)).call.apply(_getPrototypeOf3, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "state", {
      assertiveMessage1: '',
      assertiveMessage2: '',
      politeMessage1: '',
      politeMessage2: ''
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "useAlternatePolite", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "useAlternateAssertive", false);
    return _this2;
  }

  (0, _createClass2["default"])(LiveRegion, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          oldAssertiveMessage = _this$props.assertiveMessage,
          oldPoliteMessage = _this$props.politeMessage;
      var assertiveMessage = nextProps.assertiveMessage,
          politeMessage = nextProps.politeMessage;

      if (oldPoliteMessage !== politeMessage) {
        this.setState({
          politeMessage1: this.useAlternatePolite ? '' : politeMessage,
          politeMessage2: this.useAlternatePolite ? politeMessage : ''
        });
        this.useAlternatePolite = !this.useAlternatePolite;
      }

      if (oldAssertiveMessage !== assertiveMessage) {
        this.setState({
          assertiveMessage1: this.useAlternateAssertive ? '' : assertiveMessage,
          assertiveMessage2: this.useAlternateAssertive ? assertiveMessage : ''
        });
        this.useAlternateAssertive = !this.useAlternateAssertive;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          assertiveMessage1 = _this$state2.assertiveMessage1,
          assertiveMessage2 = _this$state2.assertiveMessage2,
          politeMessage1 = _this$state2.politeMessage1,
          politeMessage2 = _this$state2.politeMessage2;
      return _react["default"].createElement(_VisuallyHidden["default"], {
        element: "div"
      }, _react["default"].createElement(MessageBlock, {
        "aria-live": "assertive",
        message: assertiveMessage1
      }), _react["default"].createElement(MessageBlock, {
        "aria-live": "assertive",
        message: assertiveMessage2
      }), _react["default"].createElement(MessageBlock, {
        "aria-live": "polite",
        message: politeMessage1
      }), _react["default"].createElement(MessageBlock, {
        "aria-live": "polite",
        message: politeMessage2
      }));
    }
  }]);
  return LiveRegion;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", {
  assertiveMessage: _propTypes["default"].string,
  politeMessage: _propTypes["default"].string
}), _temp)) || _class;

exports.LiveRegion = LiveRegion;

var MessageBlock = function MessageBlock(_ref) {
  var message = _ref.message,
      ariaLive = _ref['aria-live'];
  return _react["default"].createElement(_VisuallyHidden["default"], {
    element: "div",
    "aria-live": ariaLive,
    "aria-relevant": "additions",
    "aria-atomic": "true"
  }, message || '');
};

exports.MessageBlock = MessageBlock;
MessageBlock.propTypes = {
  message: _propTypes["default"].string,
  'aria-live': _propTypes["default"].string.isRequired
};

var LiveRegionMessage =
/*#__PURE__*/
function (_Component3) {
  (0, _inherits2["default"])(LiveRegionMessage, _Component3);

  function LiveRegionMessage() {
    (0, _classCallCheck2["default"])(this, LiveRegionMessage);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf4["default"])(LiveRegionMessage).apply(this, arguments));
  }

  (0, _createClass2["default"])(LiveRegionMessage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.announce();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.message !== prevProps.message) {
        this.announce();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.clearOnUnmount) {
        LiveRegionAnnouncer.clearMessage();
      }
    }
  }, {
    key: "announce",
    value: function announce() {
      var _this$props2 = this.props,
          message = _this$props2.message,
          ariaLive = _this$props2['aria-live'];

      if (ariaLive === 'assertive') {
        LiveRegionAnnouncer.announceAssertive(message || '');
      }

      if (ariaLive === 'polite') {
        LiveRegionAnnouncer.announcePolite(message || '');
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return LiveRegionMessage;
}(_react.Component);

exports.LiveRegionMessage = LiveRegionMessage;
(0, _defineProperty2["default"])(LiveRegionMessage, "propTypes", {
  message: _propTypes["default"].string.isRequired,
  'aria-live': _propTypes["default"].string.isRequired,
  clearOnUnmount: _propTypes["default"].bool
});